import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { upperMenuHeight } from "../../../../common/parameters";

export const UpperMenu = styled.div`
    height: ${upperMenuHeight}px;
    background-color: ${p => p.theme.c.boost};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    color: ${p => p.theme.c.snowOnActive};
    line-height: 30px;
    display: flex;
    align-items: center;
    z-index: 2;
    box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow3};
    ${p => p.theme.withNotch(css`
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
    `)}

    button {
        background-color: transparent;
        outline: none;
        border: none;
    }
`;

const MenuSide = styled.div`
    flex: 1;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .arrow-back {
        width: 32px;
        height: 32px;
        display: block;
    }
`;

export const MenuRight = styled(MenuSide)`
    left: 2px;
    right: auto;
    justify-content: flex-end;
`;

export const MenuLeft = styled(MenuSide)`
    ${p =>
        p.theme.xs(css`
            flex: none;
        `)}
`;

export const Progress = styled.div`
    display: inline-block;
    font-size: 18px;
`;

export const ArrowButton = styled.button`
    padding: 0 10px;
    z-index: 100;
    cursor: pointer;
    height: 50px;
    ${p =>
        p.theme.xs(css`
            padding: 0 6px;
        `)}
    .i-arrowback {
        color: ${p => p.theme.c.whiteOnActive};
        position: relative;
        top: 1px;
        font-size: 36px;
    }

    &.Flip {
        .i-arrowback {
            transform: scale(-1, 1);
            display: inline-block;
        }
    }

    &.Inactive {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
    }
`;

export const Logo = styled(Link)`
    margin-left: 6px;
    color: ${p => p.theme.c.snowOnActive};
    display: flex;
    align-items: center;
    position: relative;
    transition: 400ms;
    svg {
        fill: ${p => p.theme.c.whiteOnActive};
    }
`;

export const JoinBanner = styled.div`
    top: 4px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 0;
    font-weight: 300;
    font-size: 18px;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}

    .class-key {
        color: ${p => p.theme.c.info};
    }
`;

export const Students = styled.div`
    position: relative;
    min-width: 150px;
    height: ${upperMenuHeight}px;
    display: flex;
    text-align: right;
    align-items: center;
`;

export const StudentsDropdown = styled.div`
    position: absolute;
    top: ${upperMenuHeight}px;
    left: 0;
    width: 100%;
    background-color: ${p => p.theme.c.boost};
    max-height: 300px;
    overflow-y: auto;
`;

export const Student = styled.div`
    padding: 4px 12px;
    text-align: left;
    .i-check {
        color: ${p => p.theme.c.pale};
        font-size: 22px;
        position: relative;
        top: 4px;
        margin-left: 3px;
    }
`;

export const StudentsSummary = styled.div`
    text-align: right;
    padding-right: 12px;
    flex: 1;
    font-size: 18px;
`;

export const Button = styled.div`
    padding: 2px 8px;
    margin: 0 8px;
    cursor: pointer;
    font-weight: 300;

    [class^="i-"] {
        font-size: 21px;
        top: 4px;
        position: relative;
        margin-right: 4px;
    }

    &:hover {
        opacity: 0.7;
    }
`;

export const MenuOpener = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}

    padding: 16px 12px;
    cursor: pointer;
    align-items: center;
    display: inline-block !important;

    .Line {
        width: 21px;
        margin-top: 4px;
        height: 3px;
        background-color: ${p => p.theme.c.dark};
        transition: 0.3s;

        &.Line1 {
            margin-top: 0;
        }
    }

    .Active {
        .Line1 {
            transform: rotate(-45deg) translate(-4.7px, 5.2px) scale(1.24, 1);
        }

        .Line2 {
            transform: scale(0, 1);
        }

        .Line3 {
            transform: rotate(45deg) translate(-4.7px, -5.2px) scale(1.24, 1);
        }
    }
`;

export const MenuDropdown = styled.div`
    position: absolute;
    top: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${p => p.theme.c.boost};
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
    padding: 8px;
`;
